/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { Button, Modal } from '@scuf/common';
import '../../scss/VirtualMeters.scss';

interface IVirtualMetersModalProps {
  modalOpen: boolean;
  hideModal(): void;
}

const VirtualMetersModal = (props: IVirtualMetersModalProps) => {
  return (
    <Modal
      className="emaas-virtual-meters-list-modal"
      open={props.modalOpen}
      onClose={props.hideModal}
      closeIcon={true}
    >
      <Modal.Header className="vm-popup-header">
        Meters Under Virtual Meter
      </Modal.Header>
      <Modal.Content>Some Physical Meters will be listed here.</Modal.Content>
      <Modal.Footer>
        <div className="buttons-section">
          <Button type="primary" content="Close" onClick={props.hideModal} />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default VirtualMetersModal;
